import { formatDistanceToNow } from "date-fns";

export function formatNotificationTime(dateString: string): string {
  const date = new Date(dateString);
  return formatDistanceToNow(date, { addSuffix: true });
}
